/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MeterDetails = {
    properties: {
        id: {
            type: 'string',
            format: 'uuid',
        },
        serviceAddressId: {
            type: 'string',
            format: 'uuid',
        },
        routeId: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        type: {
            type: 'UtilityTypeEnum',
        },
        meterNumber: {
            type: 'string',
            isNullable: true,
        },
        location: {
            type: 'string',
            isNullable: true,
        },
        isActive: {
            type: 'boolean',
        },
        serviceAddress: {
            type: 'ServiceAddressDetails',
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
        },
        createdBy: {
            type: 'string',
            format: 'uuid',
        },
        createdByUser: {
            type: 'string',
            isNullable: true,
        },
        modifiedAt: {
            type: 'string',
            isNullable: true,
            format: 'date-time',
        },
        modifiedBy: {
            type: 'string',
            isNullable: true,
            format: 'uuid',
        },
        modifiedByUser: {
            type: 'string',
            isNullable: true,
        },
    },
};